import { render } from "./ModuleComplianceUnit.vue?vue&type=template&id=6ad49c7a&scoped=true"
import script from "./ModuleComplianceUnit.vue?vue&type=script&lang=js"
export * from "./ModuleComplianceUnit.vue?vue&type=script&lang=js"

import "./ModuleComplianceUnit.vue?vue&type=style&index=0&id=6ad49c7a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ad49c7a"]])

export default __exports__